module.exports = __webpack_public_path__ + "img/desarrollo_productos.f0ebe6b8.svg";